import request from '../utils/request';

export const shippingApi = {
  // 获取发货列表
  getShippingList: (params) => {
    return request({
      url: '/shipping/list',
      method: 'get',
      params: {
        orderNumber: params.orderNumber,
        customerName: params.customerName,
        shippingCompany: params.shippingCompany,
        shippingStatus: params.shippingStatus,
        startTime: params.startTime,
        endTime: params.endTime,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 发货
  shipOrder: (id, data) => {
    return request({
      url: `/shipping/ship/${id}`,
      method: 'post',
      data
    });
  },

  // 重新发货
  reshippOrder: (id) => {
    return request({
      url: `/shipping/reship/${id}`,
      method: 'post'
    });
  }
};

// 取消订单发货
export const cancelShippingOrder = (orderId) => {
  return request({
    url: '/goods-order/cancel-logistics-order',
    method: 'post',
    data: { orderId }
  });
};

// 重新打印发货单
export const reprintShippingOrder = (params) => {
  return request({
    url: '/goods-order/reprint-shipping-order',
    method: 'post',
    data: params
  });
}; 